var map = {
	"./insta-1.jpg": "c925",
	"./insta-2.jpg": "bcbd",
	"./insta-3.jpg": "4a4b",
	"./insta-4.jpg": "efdb",
	"./insta-5.jpg": "c0f9",
	"./insta-6.jpg": "e8c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3650";